import React from "react";
import AdminGroupAccountCard from "./AdminGroupAccountCard";
import '../Styles/AdminGroupAccountCardList.scss';


const AdminGroupAccountCardList = ({queriedAccounts}) => {
   console.log("Here's queried Account", queriedAccounts)
	return (
		<div className="AdminGroupAccountCardListLayout">
			{ queriedAccounts?.map((queriedAccount) => <AdminGroupAccountCard 
         queriedAccount={queriedAccount}/>)}
		</div>	
	)
}

export default AdminGroupAccountCardList;